import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  TemplateRef,
  Type,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { get } from 'lodash';
import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { IntersectionObserverDirective } from '../../directives';
import { ButtonModule } from '../button';
import { DialogModule } from '../dialog';

type Content = TemplateRef<unknown> | Type<unknown> | string;

export interface ConfirmDialogData {
  title?: string;
  content: Content;
  contentData?: unknown;
  confirmButtonText?: string;
  cancelButtonText?: string;
  disableUntilScrolledToBottom?: boolean;
  dismissible?: boolean;
}

@Component({
    imports: [
        CommonModule,
        MatDialogModule,
        DialogModule,
        MatIconModule,
        ButtonModule,
        IntersectionObserverDirective,
        DynamicModule,
        A11yModule,
    ],
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
  bottomSeen = false;
  content!: TemplateRef<unknown> | Type<unknown> | string;
  contentDataContext = { $implicit: this.vm.contentData };
  componentInputs!: InputsType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public vm: ConfirmDialogData,
    public sanitizer: DomSanitizer
  ) {
    this.content = vm.content;

    if (this.isComponent(vm.content)) {
      this.componentInputs = get(vm, 'contentData.inputs', {}) as InputsType;
    }
  }

  bottomVisibilityChange(visible: boolean): void {
    if (visible && this.bottomSeen === false) {
      this.bottomSeen = true;
    }
  }

  isString(content: Content): content is string {
    return typeof content === 'string';
  }

  isTemplateRef(content: Content): content is TemplateRef<unknown> {
    return content instanceof TemplateRef;
  }

  isComponent(content: Content): content is Type<unknown> {
    return content instanceof Type;
  }
}
